import { pruRewardsOpus as pwa } from 'white-labelling/pru-rewards-opus';

export default pwa;
